import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { RouterModule } from "@angular/router";

import { RealStateInvestmentListComponent } from "./components/real-state-investment-list/real-state-investment-list.components";
import { RealStateInvestmentDetailComponent } from "./components/real-state-investment-detail/real-state-investment-detail.component";
import { RealStateInvestmentFormDialogComponent } from "./components/real-state-investment-form-dialog/real-state-investment-form-dialog.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    RealStateInvestmentListComponent,
    RealStateInvestmentDetailComponent,
    RealStateInvestmentFormDialogComponent
  ],
  exports: [
    RealStateInvestmentListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    RouterModule,
    FormsModule,
    SharedModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatSlideToggleModule,
  ],
})
export class RealStateInvestmentModule { }
